/**
 * Display-name helpers for marketplace / gift card catalog items.
 *
 * Intl.DisplayNames covers every ISO code without shipping a name table, and
 * degrades to the raw code where the runtime doesn't support it. Callers pass
 * the active UI locale (from useFormat().locale / useTranslation().locale) so
 * names follow the user's language; with no locale the browser default is used.
 */

const displayNamesCache = new Map();

const getDisplayNames = (type, locale) => {
  const cacheKey = `${type}:${locale || ""}`;
  if (displayNamesCache.has(cacheKey)) return displayNamesCache.get(cacheKey);
  let names = null;
  try {
    names = new Intl.DisplayNames(locale || undefined, { type });
  } catch {
    names = null;
  }
  displayNamesCache.set(cacheKey, names);
  return names;
};

export const countryName = (code, locale) => {
  const upper = String(code || "").toUpperCase();
  if (!upper) return "";
  try {
    return getDisplayNames("region", locale)?.of(upper) || upper;
  } catch {
    return upper;
  }
};

// Currency names make a bare "SEK" readable in the dropdown.
export const currencyName = (code, locale) => {
  const upper = String(code || "").toUpperCase();
  if (!upper) return "";
  try {
    const name = getDisplayNames("currency", locale)?.of(upper);
    return name && name !== upper ? name : upper;
  } catch {
    return upper;
  }
};
